import { useState } from "react";
import Icon1 from "../icons/Icon";

export const ParrainageModal = ({ handleGenerateCode }) => {
  const [step, setStep] = useState(0);
  return (
    <div className="max-h-[90vh] h-full overflow-auto w-full rounded-2xl">
      <div
        className={` transition-all duration-500 relative flex flex-col rounded-2xl bg-black w-full h-full min-h-fit items-center justify-center shadow-lg shadow-black`}
      >
        {step === 0 && (
          <div className="z-20 w-full h-fit gap-1 flex flex-col items-center justify-center p-4">
            <Icon1 icon_name="hexagone-logement" size={40}></Icon1>
            <div className="text-white text-hx  mt-2">
              hexagone <span className="font-semibold">logement</span>
            </div>{" "}
            <div className="text-wshadow_75 text-h1 w-c300 text-center mt-2">
              Programme de parrainage
            </div>{" "}
            <div
              onClick={() => {
                setStep(1);
              }}
              className="mt-4 bg-white rounded-md font-medium px-3 py-2 flex hover:scale-105 transition-all duration-300 flex-row gap-2 text-black text-h2 cursor-pointer hover:outline-none hover-outline-2 hover:outline-blue-300"
            >
              Découvrir
            </div>
          </div>
        )}
        {step === 1 && (
          <div className="z-20 w-full h-fit gap-1 flex flex-col items-center justify-center p-4">
            <div className="flex flex-col text-left items-start justify-center p-4 mt-4 w-c500">
              <div className="text-white text-h1   mt-2">
                Comment devenir parrain ?
              </div>
              <div className="text-wshadow_75 text-h1   mt-4">
                Pour devenir parrain, il faut partager son code de parrainage
                avec un confrère pour qu’il puisse l’utiliser lors de son
                inscription.
              </div>
              <div
                onClick={() => {
                  setStep(2);
                }}
                className="mt-8 bg-white rounded-md font-medium px-3 py-2 flex hover:scale-105 transition-all duration-300 flex-row gap-2 text-black text-h2 cursor-pointer hover:outline-none hover-outline-2 hover:outline-blue-300"
              >
                Continuer
              </div>
            </div>
          </div>
        )}
        {step === 2 && (
          <div className="z-20 w-full h-fit gap-1 flex flex-col items-center justify-center p-4">
            <div className="flex flex-col text-left items-start justify-center p-4 mt-4 w-c500">
              <div className="text-white text-h1   mt-2">
                Règles du programme
              </div>
              <div className="text-wshadow_75 text-h1   mt-4">
                Un parrain gagne 5 crédits (300€) dès que son filleul achète 10
                crédits.
              </div>
              <div className="text-wshadow_75 text-h1  mt-2">
                Un parrain gagne 5 crédits supplémentaires (300€) quand ce même
                filleul atteint 20 crédits achetés.
              </div>{" "}
              <div className="text-wshadow_75 text-h1  mt-2">
                Un parrain peut cumuler des récompenses pour chaque filleul
                qu’il a parrainé.
              </div>{" "}
              <div
                onClick={() => {
                  setStep(3);
                }}
                className="mt-8 bg-white rounded-md font-medium px-3 py-2 flex hover:scale-105 transition-all duration-300 flex-row gap-2 text-black text-h2 cursor-pointer hover:outline-none hover-outline-2 hover:outline-blue-300"
              >
                Continuer
              </div>
            </div>
          </div>
        )}
        {step === 3 && (
          <div className="z-20 w-full h-fit gap-1 flex flex-col items-center justify-center p-4">
            <div className="flex flex-col text-left items-start justify-center p-4 mt-4 w-c500">
              <div className="text-white text-h1   mt-2">
                Prêt à devenir parrain ?
              </div>
              <div className="text-wshadow_75 text-h1   mt-4">
                Vous pouvez dès à présent générer votre code de parrainage et le
                partager à vos confrères.
              </div>

              <div
                onClick={() => {
                  handleGenerateCode();
                }}
                className="mt-8 bg-white rounded-md font-medium px-3 py-2 flex hover:scale-105 transition-all duration-300 flex-row gap-2 text-black text-h2 cursor-pointer hover:outline-none hover-outline-2 hover:outline-blue-300"
              >
                Générer mon code
              </div>
            </div>
          </div>
        )}
        <div className="absolute w-full h-full ">
          <img
            src="https://i.ibb.co/vCMD3L5L/R-flexion-Ecosyst-me-hexagone.png"
            className=" rounded-xl w-full h-full object-fill"
          ></img>
        </div>
      </div>
    </div>
  );
};
